export function createTaskAutomationApi({ apiUrl, getToken }) {
    const headers = (json = true) => {
        const h = { Authorization: `Bearer ${getToken()}` };
        if (json) h["Content-Type"] = "application/json";
        return h;
    };

    return {
        async fetchAutomations() {
            const res = await fetch(`${apiUrl}/task-automations`, { headers: headers(false) });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message || "Failed to fetch automations");
            return {
                rules: Array.isArray(data.data) ? data.data : [],
                presets: Array.isArray(data.presets) ? data.presets : [],
            };
        },

        async createAutomation(payload) {
            const res = await fetch(`${apiUrl}/task-automations`, {
                method: "POST",
                headers: headers(),
                body: JSON.stringify(payload),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message || "Failed to save automation");
            return data.data;
        },

        async enablePreset(preset) {
            const res = await fetch(`${apiUrl}/task-automations/presets`, {
                method: "POST",
                headers: headers(),
                body: JSON.stringify({ preset }),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message || "Failed to enable preset");
            return data.data;
        },

        async updateAutomation(id, payload) {
            const res = await fetch(`${apiUrl}/task-automations/${id}`, {
                method: "PUT",
                headers: headers(),
                body: JSON.stringify(payload),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message || "Failed to update automation");
            return data.data;
        },

        async deleteAutomation(id) {
            const res = await fetch(`${apiUrl}/task-automations/${id}`, {
                method: "DELETE",
                headers: headers(false),
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok) throw new Error(data.message || "Failed to delete automation");
        },
    };
}
